<template>
    <div>

        <div class="ag-theme-alpine" style="height: 200px;">
          <ag-grid-vue
            ref="gridRef"
            :rowData="localAccounts"
            :columnDefs="columnDefs"
            :defaultColDef="defaultColDef"
            style="width: 100%; height: 150px;"
            :rowSelection="{ type: 'single' }"
            @grid-ready="onGridReady"
          ></ag-grid-vue>
        </div>
        <el-button v-if="isSupplierManager" type="primary" @click="addAccounts">계좌 추가</el-button>
        <el-button v-if="isSupplierManager"  type="danger" @click="deleteAccount">계좌 삭제</el-button>
        <el-button v-if="isSupplierManager"  type="success" @click="saveAccounts">저장</el-button>
    </div>
  </template>
  <script setup>
  import { ref ,onMounted,watch} from "vue";
  import axiosInstance from "@/api/axios";
  import { useUserStore } from "@/stores/user";
  import { ElMessage } from "element-plus";


  const props = defineProps({
    supplierId: {
      type: [Number, null], // Null 허용
      required: true,
    },
   
  });
  const emit = defineEmits(["update:modelValue",  "close"]);


  const userStore = useUserStore();
  const isSupplierManager = userStore.isSupplierManager;
  


  const gridRef = ref(null);
  const gridApi = ref(null);

  const onGridReady = (params) => {
    gridApi.value = params.api; // gridApi 초기화
    console.log("Grid API Initialized:", gridApi.value);
  };

  const localAccounts = ref([]);
  const supplierId =  ref(props.supplierId );

  // 필수 값 확인 로직
  const mandatoryFieldSetter = (field) => {
    return (params) => {
      console.log("mandatoryFieldSetter ==",params )
      if (!params.newValue) {
        alert(`${field}는 필수 입력 항목입니다.`);
        return false; // 값이 설정되지 않음
      }
      params.data[field] = params.newValue;
      return true; // 값이 정상적으로 설정됨
    };
  };

  
  const columnDefs = [
    { field: "bank_name", 
      headerName: "은행명", 
      editable: true ,
      valueSetter: mandatoryFieldSetter("bank_name") , // 필수 값 확인
      cellClassRules: {
        "ag-cell-error": (params) => !params.value, // 값이 없으면 에러 스타일 적용
      },

    },
    { field: "account_number",
       headerName: "계좌번호", 
       editable: true ,
       valueSetter: mandatoryFieldSetter("account_number") , // 필수 값 확인
      cellClassRules: {
        "ag-cell-error": (params) => !params.value, // 값이 없으면 에러 스타일 적용
      },

    },
    { field: "account_holder", 
      headerName: "예금주", 
      editable: true,
      valueSetter: mandatoryFieldSetter("account_holder") , // 필수 값 확인
      cellClassRules: {
        "ag-cell-error": (params) => !params.value, // 값이 없으면 에러 스타일 적용
      },
     },
    { field: "swift_code", headerName: "SWIFT코드", editable: true },    
    
  ];

  const defaultColDef = {
    flex: 1,
    resizable: true,
    sortable: true,
    editable:true,
  };
  
  watch(() => props.supplierId, (newSupplierId) => {
    console.log("AccountGrid - supplierId 변경 감지:", newSupplierId);
    supplierId.value = newSupplierId;
  
    if (supplierId.value) {
        fetchAccounts(); // 매입처 ID가 설정되면 계좌 정보 불러오기
    }
});
  // 서버에서 계좌 리스트 조회
const fetchAccounts = async () => {
  try {
    const response = await axiosInstance.get(`/suppliers/${supplierId.value}/accounts/`);
    localAccounts.value = response.data.results; // 서버에서 받아온 데이터를 로컬 상태에 저장
    console.log("서버에서 계좌 데이터 조회 성공:", response.data);
  } catch (error) {
    console.error("서버에서 계좌 데이터를 가져오는 중 오류 발생:", error);
    alert("계좌 데이터를 가져오는 중 오류가 발생했습니다.");
  }
};

  const addAccounts = () => {
    gridApi.value.applyTransaction({
      add: [{ id: null, bank_name: "", account_number: "", account_holder: "", swift_code: "" }],
    });

      // Vue 데이터와 동기화
    syncLocalAccounts();
  };
  
  const deleteAccount = async  () => {
    const selectedNodes = gridApi.value.getSelectedNodes();

    if (selectedNodes.length > 0) {
      const selectedData = selectedNodes.map((node) => node.data);

       // 서버와 동기화
       for (const account of selectedData) {
      if (account.id) {
        try {
          await axiosInstance.delete(`/suppliers/${supplierId.value}/accounts/${account.id}/`);
          console.log("서버에서 삭제 완료:", account.id);
        } catch (error) {
          console.error("서버 삭제 중 오류 발생:", error);
          alert(`계좌 ID ${account.id} 삭제 중 문제가 발생했습니다.`);
          return;
        }
      }
    }

    
      gridApi.value.applyTransaction({
        remove: selectedNodes.map((row) => row.data),
      });
      
      // Vue 데이터와 동기화
      syncLocalAccounts();
    } else {
      alert("삭제할 행을 선택하세요.");
    }

    
  };

  const syncLocalAccounts = () => {
    // ag-grid 데이터 -> Vue 데이터 동기화
    const updatedAccounts = [];
    gridApi.value.forEachNode((node) => {
      updatedAccounts.push(node.data);
    });

    localAccounts.value = updatedAccounts; // Vue 데이터 업데이트
    console.log("Vue와 ag-grid 데이터 동기화 완료:", localAccounts.value);
  };

 
  
  const saveAccounts = async () => {
     if (!supplierId.value) {
      console.error("매입처 ID가 없습니다. 계좌 저장을 수행할 수 없습니다.");
      ElMessage.error("매입저 정보가 없습니다. 먼저 매입처를 저장하세요");
      return;
    }

        try {
        console.log("계좌정보 저장 시작:", localAccounts.value);
        console.log("계좌정보 저장 시작 supplierId:", supplierId.value);
          for (const account of localAccounts.value) {
            console.log("계좌정보 저장 시작 account.id:", account.id);

            if (account.id) {
              // 기존 데이터 수정
              await axiosInstance.put(`/suppliers/${supplierId.value}/accounts/${account.id}/`, account);
              console.log("계좌 정보 수정 완료:", account);
            } else {
              // 새 데이터 생성
              const response = await axiosInstance.post(`/suppliers/${supplierId.value}/accounts/`, account);
              account.id = response.data.id; // 새로 생성된 ID 저장
              console.log("계좌 정보 생성 완료:", account);
            }
          }

        console.log("모든 계좌 정보 저장 완료");
        ElMessage.success("계좌 정보가 성공적으로 저장 되었습니다.");

      } catch (error) {
        console.error("계좌 정보 저장 중 오류 발생:", error);
        ElMessage.error("계좌정보 저장중 오류가 발생하였습니다.");
      }
      emit("close"); // 부모에게 닫기 이벤트 전달

  };

  onMounted(() => {
    console.log("AccountGrid mounted");
    console.log(supplierId.value)

    if (supplierId.value ){
      fetchAccounts(); // 컴포넌트가 로드될 때 계좌 리스트를 서버에서 조회
    }

  });
  </script>
  